<template>
  <div class="default-page default-page-center text-center">
    <div class="text-center text-muted mb-2">
      <i class="bi bi-hourglass-split"></i>
    </div>
    <div class="text-center">
      Раздел в разработке
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArchivePage'
}
</script>

<style lang="scss" scoped>
.bi {
  font-size: 50px;
  opacity: 0.33;
}
</style>